import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getCustomer } from 'redux/customer/actions';
import { listLoyaltyTiers } from 'redux/loyaltyTiers/actions';
import { getReservationType } from 'redux/reservationTypes/actions';
import { getReservationTypeBySlug } from 'redux/reservationTypes/reducers';
// eslint-disable-next-line import/no-cycle
import AvailabilityWidget from 'reservations/availability/AvailabilityWidget';

import NoCustomer from './NoCustomer';
import Pricing from './Pricing';

const JordanEventPricing = (props) => {
  const { slug: reservationTypeSlug } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCustomer());
  }, [dispatch]);

  useEffect(() => {
    dispatch(listLoyaltyTiers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getReservationType(reservationTypeSlug));
  }, [dispatch, reservationTypeSlug]);

  const settings = useSelector((state) => state.setting.data);
  const customerReducer = useSelector((state) => state.customer);
  const loyaltyTierReducer = useSelector((state) => state.loyaltyTier);
  const reservationType = useSelector((state) =>
    getReservationTypeBySlug(state.reservationType, reservationTypeSlug)
  );
  const { data: customer } = customerReducer;
  if (!settings) {
    return null;
  }
  if (customerReducer.isFetching || loyaltyTierReducer.isFetching) {
    return <div>Loading</div>;
  }
  if (!reservationType) {
    return <div>Loading</div>;
  }
  return (
    <div className="widget-pricing">
      <Pricing reservationType={reservationType} customer={customer} />
      {!customer && <NoCustomer reservationType={reservationType} />}
      <AvailabilityWidget
        reservationTypeSlug={reservationTypeSlug}
        form={reservationTypeSlug}
      />
    </div>
  );
};

export default JordanEventPricing;
